import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';
import { UI_NewsList } from 'ui/components/3-organisms/NewsList/NewsList';

export const NewsList = ({ content }: Content.NewsList) => {
	const { title, news, link } = content ?? {};
	return (
		<CludoComment>
			<UI_NewsList heading={title} items={news} link={link} />
		</CludoComment>
	);
};
